var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QS-h4-title',{attrs:{"title":"订单付款信息"}}),_vm._v(" "),_c('QS-common-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"columns":_vm.columns,"pagination":_vm.pagination,"data":_vm.list},on:{"change":_vm.pageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }